import React, { createContext, useContext, useMemo } from "react";

export interface VSETHContextData {
  globID: string;
  static_url: string;
  environment: "extern" | "intern";
}

export const JSON_CONTEXT_DATA_ID = "vseth-context-data";

const defaultContext: VSETHContextData = {
  globID: "vseth-0000-vseth",
  static_url: "https://static.vseth.ethz.ch",
  environment: "extern",
};
export const ReactVSETHContext = createContext(defaultContext);
export const VSETHContext: React.FC<Partial<VSETHContextData>> = ({
  children,
  ...arg
}) => {
  const serverData = useMemo(() => {
    // Needed because of SSR
    if (typeof window !== "undefined") {
      const el = document.getElementById(JSON_CONTEXT_DATA_ID);
      if (el === null) return undefined;
      try {
        const data = JSON.parse(el.textContent || "");
        return data as Partial<VSETHContextData>;
      } catch (e) {
        return undefined;
      }
    }
    return undefined;
  }, []);
  const data = useMemo(
    () => ({
      globID: arg.globID || serverData?.globID || defaultContext.globID,
      static_url:
        arg.static_url || serverData?.static_url || defaultContext.static_url,
      environment:
        arg.environment ||
        serverData?.environment ||
        defaultContext.environment,
    }),
    [serverData, arg.globID, arg.environment, arg.static_url, defaultContext]
  );

  return (
    <ReactVSETHContext.Provider value={data}>
      {children}
    </ReactVSETHContext.Provider>
  );
};
export const useVSETHContext = () => useContext(ReactVSETHContext);
